import { FC } from 'react'
import { QuestionMarkTooltip } from 'src/components/QuestionMarkTooltip'
import { CommentsChartMockData } from 'src/pages/ContentAnalysisDetail/mockData/commentsChartMockData'
import { CommentsDonutChart } from './CommentsDonutChart'
import { CommentsList } from './CommentsList'
import styles from './commentsChartSection.module.scss'

const SENTIMENT_COLORS = {
  negative: '#FF6833',
  neutral: '#C7CED1',
  positive: '#8080FF',
}

interface CommentsChartSectionProps {
  analysisId: string
  data: CommentsChartMockData
  dateRangeKey?: string
  isLoading?: boolean
  platforms?: string[]
}

export const CommentsChartSection: FC<CommentsChartSectionProps> = ({
  analysisId,
  data,
  dateRangeKey,
  isLoading = false,
  platforms,
}) => {
  return (
    <div className={styles.commentsChartSection}>
      <div className={styles.header}>
        <div className={styles.titleWrapper}>
          <span className={styles.title}>Comments Chart</span>
          <QuestionMarkTooltip
            overlay="View sentiment analysis of comments across your tracked sources"
            placement="top"
          />
        </div>
      </div>

      <div className={styles.content}>
        <CommentsDonutChart data={data} isLoading={isLoading} />
        <CommentsList
          analysisId={analysisId}
          comments={data.comments}
          dateRangeKey={dateRangeKey}
          isLoading={isLoading}
          platforms={platforms}
        />
      </div>

      <div className={styles.legend}>
        <div className={styles.legendItem}>
          <span
            className={styles.legendDot}
            style={{ backgroundColor: SENTIMENT_COLORS.positive }}
          />
          <span className={styles.legendLabel}>Positive</span>
        </div>
        <div className={styles.legendItem}>
          <span
            className={styles.legendDot}
            style={{ backgroundColor: SENTIMENT_COLORS.neutral }}
          />
          <span className={styles.legendLabel}>Neutral</span>
        </div>
        <div className={styles.legendItem}>
          <span
            className={styles.legendDot}
            style={{ backgroundColor: SENTIMENT_COLORS.negative }}
          />
          <span className={styles.legendLabel}>Negative</span>
        </div>
      </div>
    </div>
  )
}
